import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from "vue-cookies"
import VueSweetalert2 from 'vue-sweetalert2'
import Vuelidate from 'vuelidate'
import Multiselect from 'vue-multiselect'

// Added vuetify for v-data-table
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
  components,
  directives,
})

const app=createApp(App);
app.use(store);
app.use(router);
app.use(VueCookies);
app.use(VueSweetalert2);
app.use(Vuelidate);
app.use(vuetify);
app.component("Multiselect",Multiselect);

app.mount('#app');
